import { Directive, ElementRef, EventEmitter, Host, Output, Renderer2, Self } from "@angular/core";
import { DeviceService } from "@src/app/servicios/device/device.service";
import { PlatformService } from "@src/app/servicios/platform/platform.service";
import { ReelsLoaderComponent } from "../reels-loader/reels-loader.component";

const preventDefault = (event) => {
  event.preventDefault();
  event.stopPropagation();
};
/**
 * Directiva que detecta cuando un elemento entra en el viewport del navegador y emite un evento. Sirve para encajar el scroll en un elemento específico.
 */
@Directive({
  selector: "[appIntersectionScroll]",
  standalone: true,
})
export class IntersectionScrollDirective {
  @Output() exit = new EventEmitter<void>();

  private observer: IntersectionObserver;
  private isScrolling = false;
  private intersected = false;

  constructor(
    private el: ElementRef,
    private platformService: PlatformService,
    private renderer: Renderer2,
    @Host() @Self() private component: ReelsLoaderComponent,
    private deviceService: DeviceService,
  ) {
    if (!this.platformService.isBrowser()) return;
    this.observer = new IntersectionObserver(this.onIntersection, {
      root: null, // Usa el viewport del navegador como contenedor
      threshold: this.deviceService.getOS().name === "iOS" ? 0.6 : 0.3, // 50% del div debe estar visible para activar el callback
    });

    this.observer.observe(this.el.nativeElement);
  }

  private onIntersection = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.target instanceof HTMLElement) {
        if (this.isScrolling) return;
        this.component.receive();
        this.intersected = true;
        this.disableInteractions();
        if (this.deviceService.getOS().name === "iOS") {
          entry.target.scrollIntoView({ block: "center" });
        } else {
          const topOfElement = entry.target.offsetTop;
          window.scrollTo({ top: topOfElement, behavior: "smooth" });
        }

        this.isScrolling = true;

        setTimeout(() => {
          this.isScrolling = false;
        }, 500);
      }

      if (!entry.isIntersecting && this.intersected) {
        this.intersected = false;
        this.exit.emit();
      }
    });
  };

  disableInteractions() {
    document.body.style.overflow = "hidden";

    document.addEventListener("click", preventDefault, { passive: false });
    document.addEventListener("touchstart", preventDefault, { passive: false });
    document.addEventListener("touchmove", preventDefault, { passive: false });
    document.addEventListener("touchend", preventDefault, { passive: false });
    document.addEventListener("wheel", preventDefault, { passive: false });

    setTimeout(this.enableInteractions, 500);
  }

  enableInteractions() {
    document.body.style.overflow = "";

    document.removeEventListener("click", preventDefault);
    document.removeEventListener("touchstart", preventDefault);
    document.removeEventListener("touchmove", preventDefault);
    document.removeEventListener("touchend", preventDefault);
    document.removeEventListener("wheel", preventDefault);
  }
}
